module.exports = __webpack_public_path__ + "static/media/favicon.1e445fd2.ico";